import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/share.png'
import _imports_1 from '../../assets/close.png'


const _hoisted_1 = { class: "stop-map-dialog" }
const _hoisted_2 = { class: "dialog__container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("section", { class: "map__container" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "map" })
], -1)
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 前往導航 ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", {
          class: "gps-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goUseGps && _ctx.goUseGps(...args)))
        }, _hoisted_7),
        _createElementVNode("div", {
          class: "close-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_9)
      ])
    ])
  ]))
}